import { getInit } from './init.action';
import store from '../store';
import { apiServices } from '../services/api.services';
import { toast } from 'react-toastify';
import i18n from '../../i18n';

export const setBeacon = (bool) => {
    return async (Dispatch) => {
        Dispatch({type: 'RLINK_SET_BEACON', beacon: bool});
        if (bool) getInit();
    };
};

export const setRedirect = (url) => {
    window.location.hostname !== 'localhost' && store.dispatch({type: 'RLINK_SET_REDIRECT', redirect: url});
};

export const sendPaypalTransaction = (id) => {
    if (!id) return false;
    apiServices.post("/registertx", { tx: id }).then(() => {
        console.log('registertx send id: ', id);
    }).catch(err => {
        return err;
    });
}

export const confirmRedeemCodeValue = (code) => {
    apiServices.post("/redeem", { code }).then((response) => {
        if (!response.data.success) {
            if (response.data.error && response.data.msg) {
                return toast.error(i18n.t(`profile:redeem.${response.data.msg}`));
            }
            return;
        } else {
            const result = response.data.result;
            toast.success(i18n.t('profile:redeem.codeRedeemed', {time: result.days*24}));
            result.days = (result.days * 86400);
            store.dispatch({type: 'UPDATE_VIP', plan: result.plan, remain: result.days});
        }
        
    }).catch(err => {
        return err;
    });
}

export const callTrial = () => {
    return async (Dispatch) => {
        apiServices.get("/trial").then((res) => {
            if (res && res.data && res.data.success) {
                Dispatch({type: 'ADD_TRIAL'});
                toast.success(i18n.t('common:trialNotification'));
            }
        }).catch(err => {
            return err;
        });
    };
}

export const resync = () => {
    return async (Dispatch) => {
        apiServices.get("/resync").then((res) => {
            if (res && res.data && res.data.success) {
                toast.success(i18n.t('setup:resynchronized'));
                Dispatch({type: 'RESYNC'});
            }
            else toast.success(i18n.t('setup:resynchronizedError'));
        }).catch(err => {
            return err;
        });
    };
}

export const checkServers = (name) => {
    return new Promise((resolve, reject) => {
        apiServices.post("/checkServer", {name}).then((res) => {
            return resolve(res);
        }).catch(err => {
            return reject(err);
        });
    });
}